import Fetcher from '../../../services/Fetcher'
import {
  API_DICTIONARY,
  HTTP_METHODS,
  ResponseWithPagination
} from '../../../constants'
import {
  CreateCognusARDisputeRequestData,
  InvoicesTableRecord,
  MarketplaceARRebateCorrelationCheckRequestData,
  MarketplaceARRebateCorrelationCheckResponseData,
  PaymentStatusList,
  PaymentStatusRequest,
  TCognusARInvoicesTableRequest
} from './types'

const fetcher = new Fetcher({})

export const getPaymentStatusData = async (data) =>
  fetcher.request<PaymentStatusRequest, PaymentStatusList>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.MARKETPLACE_AR}${API_DICTIONARY.PAYMENT_BY_STATUS}`,
    method: HTTP_METHODS.GET,
    ...data
  })

export const getCognusARInvoicesData = async (id, data) =>
  fetcher.request<
    TCognusARInvoicesTableRequest,
    ResponseWithPagination<InvoicesTableRecord>
  >({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.MARKETPLACE_AR}${id}/${API_DICTIONARY.INVOICES}`,
    method: HTTP_METHODS.GET,
    ...data
  })

export const createCognusARDispute = async (
  id: string,
  data: CreateCognusARDisputeRequestData
) =>
  fetcher.request<CreateCognusARDisputeRequestData, unknown>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.MARKETPLACE_AR}${id}/${API_DICTIONARY.INVOICES}${API_DICTIONARY.DISPUTE}`,
    method: HTTP_METHODS.POST,
    data
  })

export const marketplaceARRebateCorrelationCheckRequest = async (
  id: string,
  data: MarketplaceARRebateCorrelationCheckRequestData
) =>
  fetcher.request<
    MarketplaceARRebateCorrelationCheckRequestData,
    MarketplaceARRebateCorrelationCheckResponseData
  >({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.MARKETPLACE_AR}${id}/${API_DICTIONARY.INVOICES}${API_DICTIONARY.REBATE_CORRELATION}`,
    method: HTTP_METHODS.POST,
    data
  })
